import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MobileShell from "@/components/MobileShell";
import { Button } from "@/components/ui/button";
import api, { formatApiError } from "@/lib/api";
import { activePrescriptionRows } from "@/lib/prescriptionDelivery";

function hasExercises(data) {
  const plans = Array.isArray(data?.active_plans)
    ? data.active_plans : [data?.active_home_plan, data?.active_program_plan].filter(Boolean);
  return plans.length > 0
    ? activePrescriptionRows(plans).length > 0
    : (data?.condition?.exercises || []).length > 0;
}

export default function CurrentExercises() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let active = true;
    setError("");
    api.get("/dashboard/me")
      .then(({ data }) => {
        if (!active) return;
        if (!hasExercises(data)) {
          navigate("/dashboard", { replace: true });
          return;
        }
        const weekIndex = Number.isInteger(data.current_week_idx) && data.current_week_idx >= 0
          ? data.current_week_idx
          : 0;
        navigate(`/session/${weekIndex}/0`, { replace: true });
      })
      .catch((err) => active && setError(formatApiError(err.response?.data?.detail) || "Unable to load your exercises."));
    return () => { active = false; };
  }, [navigate, reloadKey]);

  return <MobileShell><div className="px-6 pt-12 text-slate-500" role={error ? "alert" : "status"}>{error || "Opening your exercises…"}{error && <Button className="mt-4 block" onClick={() => setReloadKey((key) => key + 1)}>Try again</Button>}</div></MobileShell>;
}
